import {Component, OnInit, ViewChild} from '@angular/core';
import {User} from '../../../dto/user';
import {UserLastLocations} from '../../../dto/user-location/user-last-locations';
import {Market} from '../../../dto/market';
import {MarketLevel} from '../../../dto/market-level';
import {UserRole} from '../../../dto/user-role';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import 'leaflet.gridlayer.googlemutant';
import {base_urls} from '../../../config/base_urls';
import {DatePipe} from '@angular/common';
import * as L from 'leaflet';
import {DivIcon} from 'leaflet';
import {AuthService} from '../../../services/auth.service';
import {BaseService} from '../../../services/base.service';
import {takeUntil, tap} from 'rxjs/operators';
import {DaterangepickerDirective, LocaleConfig} from 'ngx-daterangepicker-material';
import {MarketService} from '../../../services/market.service';
import {GeneralBroadcastService} from '../../../services/general-broadcast.service';
import {ReplaySubject, Subject} from 'rxjs';
import {FormControl} from '@angular/forms';
import {MatSelectChange} from '@angular/material';

@Component({
    selector: 'app-user-last-locations',
    templateUrl: './user-last-locations.component.html',
    styleUrls: ['./user-last-locations.component.scss']
})
export class UserLastLocationsComponent implements OnInit {

    lat = 23.8383283;
    lon = 90.3759853;
    loggedUser: User;
    locationList: UserLastLocations[] = [];
    loadingData = false;
    filteredMarket: ReplaySubject<Market[]> = new ReplaySubject<Market[]>(1);
    marketFilterForm: FormControl = new FormControl();
    filteredMarketList = [];
    marketIndex = 0;
    marketLoading = false;
    marketLevelId = null;
    userRank: number;
    marketLevels: MarketLevel[] = [];
    markets = [];
    selectedMarket: Market[] = [];

    userRoles: UserRole[];
    map: any;
    filters = {
        'date': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        'marketId': null,
        'roleId': null,
        userId: null,
        fileType: null,
        downloadFileName: null,
    };

    markerClusterGroup = L.markerClusterGroup({
        iconCreateFunction: function (cluster): DivIcon {
            const count = cluster.getChildCount();
            return L.divIcon({
                html: '<div style="background-color: rgba(17,156,231,0.8);' +
                    'border-radius: 50%; ' +
                    'height: 40px; ' +
                    'width: 40px; ' +
                    'font-size: 10px; ' +
                    'font-weight: 700; ' +
                    'display: flex; ' +
                    'justify-content: center; ' +
                    'font-family: Muli; ' +
                    'border: 2px solid rgba(45,45,45,0.5); ' +
                    'align-items: center;">' + count + '</div>',
                className: '',
                iconSize: L.point(40, 40)
            });
        }
    });

    customStyle = [
        {
            'featureType': 'landscape',
            elementType: 'geometry',
            'stylers': [
                {'hue': '#37cb37'},
                {'saturation': -20},
                {'lightness': -8}
            ]
        }
    ];
    calendarLocale: LocaleConfig;
    ranges: any;
    selectedRange: any = {startDate: null};
    datePipe = new DatePipe('en-US');
    isCalenderOpen = false;

    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();

    private _unsubscribeAll: Subject<any>;

    @ViewChild(DaterangepickerDirective, {static: true}) dateRangePicker: DaterangepickerDirective;

    constructor(private auth: AuthService, private service: BaseService, private marketService: MarketService,
                private generalBroadcastService: GeneralBroadcastService) {
        this._unsubscribeAll = new Subject();
        this.generalBroadcastService.broadcastTitle('User Last Locations');
        this.generalBroadcastService.broadcastSelectedModuleId('LOCATION');
        this.loggedUser = this.auth.user;
        this.marketLevels = marketService.marketLevels;
        this.marketLevels.forEach(pMarketLevel => {
            this.markets[pMarketLevel.Rank] = [];
            this.selectedMarket[pMarketLevel.Rank] = null;
            const filteredMarket: ReplaySubject<Market[]> = new ReplaySubject<Market[]>(1);
            this.filteredMarketList.push(filteredMarket);
        });
        this.userRank = marketService.userRank;
        this.selectedMarket = this.marketService.prepareUserMarket();
        this.calendarLocale = {
            customRangeLabel: 'Pick a date...',
            applyLabel: 'Apply',
            cancelLabel: 'Clear',
            format: 'DD-MMM-YYYY',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        };

        this.selectedRange.startDate = moment().subtract(0, 'days').startOf('day');
    }

    ngOnInit(): void {
        this.map = L.map('map').setView([23.8383283, 90.3759853], 7);
        L.gridLayer.googleMutant({
            type: 'roadmap',
            styles: this.customStyle,
            minZoom: 7,
            maxZoom: 22
        }).addTo(this.map);

        this.loadInitialMarkets();
        this.marketFilterForm.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.markets[this.marketIndex]) {
                return;
            }

            const search = this.marketFilterForm.value;
            if (!search) {
                this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
                return;
            }

            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].filter(product => product.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 || product.Code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });

        this._getUserList();
        this.userFilter.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.userList) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUserList.next(this.userList.slice());
                return;
            }
            this._getUserList(search);
            this.filteredUserList.next(this.userList.filter(user => user.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 || user.Code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });

        this.service.getUserRoleList({
            Active: true,
            UserType: null
        })
            .pipe(
                tap(response => {
                    this.userRoles = response;
                })
            )
            .subscribe();
    }

    dateChangeListener(pEvent: any): void {
        this.filters.date = this.datePipe.transform(this.selectedRange.startDate, 'yyyy-MM-dd');
        this.isCalenderOpen = false;
    }

    compareMarkets(pMarket1: Market, pMarket2: Market): boolean {
        return pMarket1 && pMarket2 && pMarket1.Id === pMarket2.Id;
    }

    loadInitialMarkets(): void {
        this.marketService.getInitialMarketList().subscribe(responses => {
            responses.forEach((pResponse, index) => {
                const pMarketLevel = this.marketLevels[index];
                this.markets[pMarketLevel.Rank] = pResponse;
                this.filteredMarketList[index].next(this.markets[pMarketLevel.Rank].slice());
            });
        });
    }

    marketFilterChangeListener(pEvent: MatSelectChange): void {
        this.marketService.marketChangeListener(pEvent, this.marketIndex, this.selectedMarket).subscribe(pResponse => {
            this.selectedMarket = pResponse;
        });
    }

    getSelectedLevelMarkets(marketLevel: MarketLevel): void {
        this.marketIndex = marketLevel.Rank;
        this.marketService.getSelectedLevelMarkets(marketLevel, this.selectedMarket).subscribe(pResponse => {
            this.markets[this.marketIndex] = pResponse;
            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
        });
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }

        this.service.getUserList({
            ResponseFields: 'Id,Code,Name,Active',
            UserType: null,
            MarketIdList: marketIdList,
            PageNumber: 0,
            RecordsPerPage: 50,
            SearchKey: search
        }).subscribe(pUsers => {
            this.userList = pUsers;
            this.filteredUserList.next(this.userList.slice());
        });
    }

    openFilterModal(): void {
        const modal = document.getElementById('filterModal');
        modal.style.display = 'block';
    }

    closeFilterModal(): void {
        const modal = document.getElementById('filterModal');
        modal.style.display = 'none';
    }

    openPicker(): void {
        this.isCalenderOpen = !this.isCalenderOpen;
        if (this.isCalenderOpen) {
            this.dateRangePicker.open();
        } else {
            this.dateRangePicker.hide();
        }
    }

    resetParameters(): void {
        for (let i = 0; i < this.selectedMarket.length; i++) {
            if (this.userRank) {
                if (this.selectedMarket[i] &&
                    this.selectedMarket[i].MarketLevel.Rank > this.userRank) {
                    this.selectedMarket[i] = null;
                }
            } else {
                if (this.selectedMarket[i]) {
                    this.selectedMarket[i] = null;
                }
            }
        }
        this.filters.roleId = null;
        this.filters.userId = null;

    }

    getLocationList(): void {
        this.filters.marketId = null;
        this.loadingData = true;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.filters.marketId = this.selectedMarket[i].Id;
                break;
            }
        }
        this.markerClusterGroup.clearLayers();
        this.service.getUserLastLocations(this.filters, base_urls.p_base)
            .pipe(
                tap(locationList => {
                    this.loadingData = false;
                    if (locationList.length > 0) {
                        locationList.forEach(pLocation => {
                            // const monitorUrl = `/location/monitoring-user-timeline?userCode=${pLocation.user.code}`;
                            if ((pLocation.latitude > 0 && pLocation.latitude <= 90) && (pLocation.longitude > 0 && pLocation.longitude <= 180)) {
                                const customIcon = L.divIcon({
                                    html: '<div>' +
                                        `<img src="/assets/icons/location-icons/ic_pin_red.svg" style="width: 50px; height: 50px; position: relative" >` +
                                        `<img src="${pLocation.userImage || '/assets/images/no_image.jpg'}" style="width: 31px; height: 30px; left: 9px; top: 2px; border-radius: 50%; position: absolute" >` +
                                        '</div>',
                                    iconSize: [50, 50],
                                    iconAnchor: [25, 50],
                                    className: ''
                                });
                                let lastUpdated = '';
                                if (pLocation.tillTime) {
                                    const now = new Date();
                                    const updated = new Date(pLocation.tillTime);
                                    const diffMs = now.getTime() - updated.getTime();
                                    const diffMins = Math.floor(diffMs / 60000);

                                    if (diffMins < 60) {
                                        lastUpdated = diffMins <= 1 ? 'a minute ago' : `${diffMins} minutes ago`;
                                    } else {
                                        lastUpdated = new DatePipe('en-US').transform(updated, 'h:mm a');
                                    }
                                }
                                const marker = L.marker([pLocation.latitude, pLocation.longitude], {icon: customIcon})
                                    .bindPopup(`
                                        <div style="display: flex; align-items: center; flex-direction: row; gap: 10px">
                                            <div>
                                                <img style="border-radius: 50%; height: 100px; width: 100px;" 
                                                    src="${pLocation.userImage || '/assets/images/no_image.jpg'}">
                                            </div>
                                            <div style="display: flex; flex-direction: column; gap: 5px">
                                                <a target="_blank" href="/location/user-timeline-by-date-range?userCode=${pLocation.user.code}&userId=${pLocation.user.id}&date=${this.filters.date}" style="font-size: 15px; font-weight: bold; font-family: Muli; margin-left: 4px">
                                                    ${pLocation.user.name}(${pLocation.user.code})
                                                </a>
                                                <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                                                    <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; gap: 2px; flex-direction: row">
                                                        <img style="height: 20px; width: 20px;" src="/assets/icons/location-icons/battery-charging.svg">
                                                        <div style="color: #737373; font-weight: bold">${pLocation.batteryStatus ? (pLocation.batteryStatus * 100) + '%' : 'N/A'}</div>
                                                    </div>
                                                    
                                                    ${pLocation.tillTime ? `
                                                        <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; flex-direction: row; gap: 2px">
                                                            <img style="height: 16px; width: 16px;" src="/assets/icons/location-icons/clock-2.svg">
                                                            <div style="color: #737373; font-weight: bold">${this.datePipe.transform(pLocation.tillTime, 'hh:mm a')}</div>
                                                        </div>
                                                        ` : ''}
                                                    
                                                    ${pLocation.durationStr ? `
                                                        <div style="font-size: 12px; font-family: Muli; display: flex; flex-direction: row; align-items: center; gap: 2px">
                                                            <div style="height: 5px; width: 5px; border-radius: 50%; background-color: #737373"></div>
                                                            <div style="color: #737373; font-weight: bold">${pLocation.durationStr}</div>
                                                        </div>
                                                        ` : ''}
                                                </div>
                                                <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; flex-direction: row; gap: 2px">
                                                    <img style="height: 20px; width: 20px;" src="/assets/icons/location-icons/map-pin.svg">
                                                    <div style="color: #737373; font-weight: bold">${pLocation.address}</div>
                                                </div>
                                            </div>
                                        </div>
                                        `, {minWidth: 400, maxWidth: 800});
                                this.markerClusterGroup.addLayer(marker);
                            }
                        });
                        this.map.addLayer(this.markerClusterGroup);

                    }
                })
            )
            .subscribe();
    }

}
